import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'sections/Services/TradeFinance/components/SectionAbout/SectionAbout.module.scss';

const cn = classNames.bind(styles);

const SectionAbout = (): ReactElement => {
  const { width: screenWidth } = useWindowSize();

  const renderHeadingByScreenWidth = () => {
    if (screenWidth >= 1025) {
      return (
        <>
          <span>What is</span>{' '}
          <span>DP World Trade Finance?</span>
        </>
      );
    }
    if (screenWidth <= 1024) {
      return (
        <>
          <span>What is DP World</span>{' '}
          <span>Trade Finance?</span>
        </>
      );
    }
  };

  return (
    <section className={cn('about')}>
      <div className={cn('container')}>

        <div className={cn('about__content')}>

          {/* IMAGE BLOCK */}
          <div className={cn('about__image-container')}>
            <picture>
              <source
                srcSet="
                /images/pages/Services/TradeFinance/planet-mobile.webp 1x,
                /images/pages/Services/TradeFinance/planet-mobile@2x.webp 2x
              "
                sizes="100vw"
                media="(max-width: 768px)"
              />
              <source
                srcSet="
                /images/pages/Services/TradeFinance/planet-tablet.webp 1x,
                /images/pages/Services/TradeFinance/planet-tablet@2x.webp 2x
              "
                sizes="100vw"
                media="(max-width: 1024px)"
              />
              <source
                srcSet="
                /images/pages/Services/TradeFinance/planet-desktop.webp 1x,
                /images/pages/Services/TradeFinance/planet-desktop@2x.webp 2x
              "
                sizes="100vw"
              />
              <img
                className={cn('about__image')}
                src="/images/pages/Services/TradeFinance/planet-desktop.webp"
                alt="Trade Finance Planet"
              />
            </picture>
          </div>

          {/* INFO BLOCK */}
          <div className={cn('about__info-container')}>
            <h2 className={cn('about__heading')}>
              {renderHeadingByScreenWidth()}
            </h2>
            <p className={cn('about__paragraph')}>
              DFA Members gain unparalleled access to timely financing.
              Through DP World Trade Finance you can access streamlined processes
              and cutting-edge technology to{' '}
              <span>empower your business to be able to seize growth</span>{' '}
              opportunities without delay.
            </p>
            <p className={cn('about__paragraph')}>
              The comprehensive data analytics available on the platform, enable
              lenders around the globe to make informed decisions and{' '}
              <span>provide tailored financial solutions</span>.
            </p>
            <p className={cn('about__paragraph')}>
              Join us in reshaping the future of trade finance, where businesses
              thrive and financing is never a barrier to success.
            </p>
          </div>
        </div>

      </div>
    </section >
  );
};

export default SectionAbout;